<template>
  <div class="block-content">
    <div class="is-flex whole-calendar">
      <v-container>
        <v-row v-for="(chunk,index) in getDayChunks" :key="index">
            <div class="card" v-for="day in chunk">
              <header class="card-header-grey">
                <strong class="is-size-7-touch">
                  {{ day.dayOfWeek }}
                </strong>
              </header>
              <header
                  class="card-header-grey"
                  :class="{'active-day': today() === day.day}"
              >
                <strong class="is-size-7-touch">
                  {{ getMonth(day.month) }} {{ day.day }}
                </strong>
              </header>
              <div
                  v-for="(game,index) in day.venues"
                  :key="index"
                  class="card-calendar"
              >
                <div class="card-content card-content-calendar">
                  <div class="media">
                    <div class="media-content has-text-centered">
                      <div class="navbar-item has-dropdown is-hoverable">
                        <strong class="has-text-info is-fullwidth has-text-centered is-size-7-touch has-text-centered">
                          <router-link
                              :to="{name: 'VenueDetails', params: {id: game.venueid}}"
                              class="has-text-centered is-fullwidth blockLink"
                          >
                            {{ game.name }}
                          </router-link>
                        </strong>
                        <div class="navbar-dropdown">
                          <div class="card">
                            <div class="card-image">
                              <figure class="image is-2by1">
                                <img
                                    :src="game.logo"
                                    alt="Image"
                                >
                              </figure>
                            </div>
                            <div class="card-content">
                              <strong>{{ game.name }}</strong>
                              <div>{{ game.street1 }}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <strong>{{ game.city }}, {{ game.state }}</strong><br>
                      <strong class="is-darkred is-uppercase">{{ game.mark }}</strong>
                      <span v-if="game.opttext && game.opturl">
                  <br>
                  <a
                      :href="game.opturl"
                      target="_blank"
                  >
                    {{ game.opttext }}
                  </a>
                  <br>
                </span>
                      <div
                          v-if="user && user.canEditSchedule"
                          class="control"
                      >
                        <schedule-host :game="game" :fetched-hosts="fetchedHosts" @setHost="setHost" @makeDefault="makeDefault" :date="day.date" :set-host-date="setHostDate"/>
                        <!--                  <div class="select is-small is-fullwidth mb-2">
                                            <select>
                                              <option
                                                :selected="null"
                                                value=""
                                              >
                                                Choose Session
                                              </option>
                                              <option
                                                v-for="n in countStime(game)"
                                                @click="session = n"
                                              >
                                                Session {{ n }}
                                              </option>
                                            </select>
                                          </div>
                                          <div class="select is-small is-fullwidth mb-2">
                                            <select v-model="selectedHost">
                                              <option
                                                :selected="null"
                                                value=""
                                              >
                                                Schedule Host
                                              </option>
                                              <option
                                                v-for="host in fetchedHosts"
                                                :value="{date: day.date, hostId: host.id, venueId: game.venueid, session: session, gameDate: game.date}"
                                              >
                                                {{ fullName(host.first, host.last) }}
                                              </option>
                                            </select>
                                          </div>-->
                      </div>

                      <time-block :game="game" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </v-row>
      </v-container>
    </div>
    <div
      v-if="!selectDataByHost.length"
      class="has-text-centered block-content"
    >
      <!--<h5 class="subtitle is-5">
        We could not find the selected host for this date
      </h5>-->
      <img
        src="/images/dps.png"
        width="280"
      >
    </div>
  </div>
</template>

<style scoped>
.blockLink {
  width: 100%;
}
</style>
<script>
  import _ from 'lodash';
  import ScheduleHost from "@/components/calendar/ScheduleHost";
  import TimeBlock from './TimeBlock.vue'
  export default {
    name: 'WholeStyleCalendar',
    components: {
      ScheduleHost,
      TimeBlock
    },
    props: ['data', 'user', 'hosts', 'fetchedHosts', 'setHostDate', 'token', 'filteredHost'],
    data () {
      return {
        session: 1,
        selectedHost: ''
      }
    },
    computed: {
      filteredByHost () {
        if (!this.data.length) return []
        if (this.filteredHost === 'Select Host') return this.data
        let arr = []
        this.data.forEach(city => {
          let venues = []
          city.venues.forEach(game => {
            if (game.stime1_host && game.stime1_host.name === this.filteredHost) venues.push(game)
            else if (game.stime2_host && game.stime2_host.name === this.filteredHost) venues.push(game)
            else if (game.stime3_host && game.stime3_host.name === this.filteredHost) venues.push(game)
            else if (game.stime4_host && game.stime4_host.name === this.filteredHost) venues.push(game)
          })
          if (venues.length) {
            arr.push({
              venues,
              date: city.date,
              day: city.day,
              dayOfWeek: city.dayOfWeek,
              month: city.month,
              year: city.year
            })
          }
        })
        return arr
      },
      getDayChunks() {
        return _.chunk(Object.values(this.filteredByHost), 7);
      },
      selectDataByHost () {
        return this.filteredByHost
//        if (this.user && this.user.canEditSchedule) return this.filteredByHost
//        return this.data
      }
    },
    watch: {
      selectedHost (newValue) {
        if (newValue) {
          this.setHost()
          this.selectedHost = ''
        }
      }
    },
    methods: {
      today () {
        let now = new Date()
        let day = now.getDate()
        if (day < 10) return `0${day}`
        return day.toString()
      },
      getMonth (month) {
        switch (+month) {
          case 1:
            return 'Jan'
          case 2:
            return 'Feb'
          case 3:
            return 'Mar'
          case 4:
            return 'Apr'
          case 5:
            return 'May'
          case 6:
            return 'Jun'
          case 7:
            return 'Jul'
          case 8:
            return 'Aug'
          case 9:
            return 'Sep'
          case 10:
            return 'Oct'
          case 11:
            return 'Nov'
          case 12:
            return 'Dec'
          default:
            return 'Error'
        }
      },
      cutNotes (string) {
        return string.split('<br>')[0]
      },
      fullName (first, last) {
        return `${first} ${last}`
      },
      setHost (date, session, venueId, hostId, gameDate) {
        this.$emit('setHost', date, session, venueId, hostId, gameDate)
      },
      makeDefault (calId, session, venueId, hostId) {
        this.$emit('makeDefault', calId, session, venueId, hostId)
      },
      countStime (venue) {
        let count = 0
        if (venue.hasOwnProperty('stime1') && venue.stime1) count++
        if (venue.hasOwnProperty('stime2') && venue.stime2) count++
        if (venue.hasOwnProperty('stime3') && venue.stime3) count++
        if (venue.hasOwnProperty('stime4') && venue.stime4) count++
        return count
      }
    }
  }
</script>
